import { defineStore } from 'pinia';
import { ref } from 'vue';
import requests from '../../../_00_elements/tools/requests';
import { flashBagSuccess, flashBagError } from '../../../_00_elements/tools/flashbag';
import { trans } from '../../../_00_elements/translation';
import {
  URL_XHR_PAY_ORGANIZATION_BILLING_INFORMATIONS,
} from '../../../_00_elements/tools/routes/routes';

const useManagePayAccount = defineStore('managePayAccount', () => {
  const organization = ref(window.initialState.organization);
  const payOrganizationBillingInformation = ref();
  const billingType = ref();
  const organizationType = ref();

  const calculateVATNumber = (siren) => {
    const clean = siren.replace(/\s/g, '');
    if (!(/^\d{9}$/.test(clean))) {
      return '';
    }

    const key = (12 + 3 * (parseInt(clean, 10) % 97)) % 97;
    return `FR${key}${clean}`;
  };

  const getBillingInformationEndpoint = () => URL_XHR_PAY_ORGANIZATION_BILLING_INFORMATIONS
    .replace('{organizationType}', organizationType.value)
    .replace('{billingType}', billingType.value);

  const createOrUpdatePayOrganizationClientBillingInformation = async () => {
    try {
      let method = 'post';
      let route = getBillingInformationEndpoint();

      if (payOrganizationBillingInformation.value.id) {
        method = 'put';
        route += `/${payOrganizationBillingInformation.value.id}`;
      }

      const { data } = await requests[method](route, payOrganizationBillingInformation.value);
      payOrganizationBillingInformation.value.id = data.payOrganizationBillingInformation.id;

      flashBagSuccess(trans('gestion.pay.informations.success'));
      return true;
    } catch (error) {
      flashBagError(error.response?.data?.message || trans('global.error'));
      return false;
    }
  };

  const setPayOrganizationBillingInformation = (value) => {
    payOrganizationBillingInformation.value = value;
  };

  const setBillingMode = (organizationTypeValue, billingTypeValue) => {
    organizationType.value = organizationTypeValue;
    billingType.value = billingTypeValue;
  };

  return {
    organization,
    payOrganizationBillingInformation,
    billingType,
    organizationType,
    createOrUpdatePayOrganizationClientBillingInformation,
    setPayOrganizationBillingInformation,
    calculateVATNumber,
    setBillingMode,
  };
});

export default useManagePayAccount;
